import { CLASS_IDS, CLASSES, type ClassId, UNLOCKS } from '@xox/shared'
import { Lock } from 'lucide-react'

interface Props {
  value: ClassId
  onChange: (cls: ClassId) => void
  unlocked: readonly ClassId[]
}

/** Knight, Rogue, Mage: one card each, locked ones say which account level opens them. */
export function ClassPicker({ value, onChange, unlocked }: Props) {
  return (
    <div className="grid grid-cols-3 gap-2" role="radiogroup" aria-label="Class">
      {CLASS_IDS.map((id) => {
        const def = CLASSES[id]
        const open = unlocked.includes(id)
        const level = UNLOCKS.find((u) => u.cls === id)?.level ?? 1
        const selected = value === id
        return (
          <button
            key={id}
            type="button"
            role="radio"
            aria-checked={selected}
            disabled={!open}
            onClick={() => onChange(id)}
            className={[
              'flex flex-col items-start gap-1 rounded-2xl p-3 text-left ring-1 transition',
              selected
                ? 'bg-slate-900 text-white ring-slate-900 dark:bg-white dark:text-slate-900 dark:ring-white'
                : 'bg-white ring-slate-200 hover:ring-sky-400 dark:bg-slate-900 dark:ring-slate-700',
              open ? '' : 'opacity-60',
            ].join(' ')}
          >
            <span className="font-black">{def.name}</span>
            <span
              className={`text-[11px] leading-tight ${selected ? 'opacity-80' : 'text-slate-500'}`}
            >
              {open ? (
                def.blurb
              ) : (
                <span className="inline-flex items-center gap-1">
                  <Lock className="size-3" aria-hidden /> Unlocks at Lv {level}
                </span>
              )}
            </span>
            <span
              className={`text-[10px] tabular-nums ${selected ? 'opacity-70' : 'text-slate-400'}`}
            >
              {def.hp} HP · {def.atk} atk · {def.def} def
            </span>
          </button>
        )
      })}
    </div>
  )
}
